import React from "react";
import { Box, Divider } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { Download } from "@mui/icons-material";

import { CustomBox } from "../../Shared/CustomBox/CustomBox";
import { CustomImage } from "../../Shared/CustomImage/CustomImage";
import { CustomTypography } from "../../Shared/CustomTypography/CustomTypography";
import { CustomButton } from "../../Shared/CustomButton/CustomButton";
import { downloadReferralToPDF } from "../../utils/downloadReferralPDF";

export const PatientReferralTo = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const referral = state?.referral;
  console.log(referral);
  if (!referral) {
    return (
      <Box p={3}>
        <CustomTypography>No referral selected</CustomTypography>
      </Box>
    );
  }

  const { referredTo, date, reason } = referral;

  return (
    <Box width="100%">
      {/* Header */}
      <CustomBox alignItems="center" mb={3} justifyContent="space-between">
        <CustomTypography
          fontSize={20}
          fontWeight={600}
          sx={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          ← Referral
        </CustomTypography>
        <CustomButton 
          onClick={() => downloadReferralToPDF(referral)}
          sx={{ p: 1, minWidth: "auto" }}
        >
          <Download sx={{ fontSize: 22, color: "#1976d2" }} />
        </CustomButton>
      </CustomBox>

      {/* Main Card */}
      <Box
        bgcolor="#fff"
        borderRadius={3}
        p={3}
        boxShadow="0px 4px 20px rgba(0,0,0,0.06)"
      >
        {/* Referred To */}
        <CustomTypography fontWeight={600} mb={2}>
          Referred To
        </CustomTypography>

        <CustomBox alignItems="center" gap={2} mb={3}>
          <CustomImage
            src={referredTo.avatar}
            width={48}
            height={48}
            radius="50%"
          />
          <CustomBox flexDirection="column">
            <CustomTypography fontWeight={600}>
              {referredTo.name}
            </CustomTypography>
            <CustomTypography fontSize={13} color="gray">
              {referredTo.specialty || "Urologist"}
            </CustomTypography>
          </CustomBox>
        </CustomBox>

        <Divider sx={{ mb: 3 }} />

        {/* Details */}
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
          <Detail label="Referral Date" value={date} />
          <Detail label="Distance" value="5.84 mi" />
          <Detail label="Contact" value="123-456-7890" />
          <Detail label="Travel Time" value="19.0 min" />
          <Detail label="Email" value={referredTo.email} />
          <Detail label="Reason" value={reason} />
          <Detail label="Working Hours" value="11:00 AM to 04:00 PM" />
          <Detail
            label="Health Plans Accepted"
            value="Aetna, Anthem Blue Cross, Blue Shield of California"
          />
          <Detail
            label="Location"
            value="Lakeview Medical Center, Seattle, WA"
          />
        </Box>

        {/* Action Button */}
        <CustomBox justifyContent="flex-end" mt={4}>
          <CustomButton
            sx={{
              backgroundColor: "#2196f3",
              color: "#fff",
              px: 3,
              py: 1,
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: "#1976d2",
              },
            }}
            // onClick={() =>
            //   navigate("/user-layout/referral-appointment", {
            //     state: { referral: state?.referral },
            //   })
            // }
             onClick={() =>
            navigate(`/user-layout/doctor-list/${state?.referral?.referredTo?.id}`, {
              state: { referral: state?.referral }, // optional
            })
          }
          >
            Schedule Appointment
          </CustomButton>
        </CustomBox>
      </Box>
    </Box>
  );
};

/* ---------- Detail Item ---------- */
const Detail = ({ label, value }: { label: string; value: string }) => (
  <CustomBox
    justifyContent="space-between"
    alignItems="center"
    sx={{
      borderBottom: "1px solid #f0f0f0",
      pb: 1,
    }}
  >
    <CustomTypography fontSize={14} color="#8a8a8a">
      {label}
    </CustomTypography>

    <CustomTypography fontSize={14} fontWeight={500}>
      {value || "-"}
    </CustomTypography>
  </CustomBox>
);
